module.exports = __webpack_public_path__ + "assets/img/nh5.c167b8b0.jpg";